import { useQuery } from '@tanstack/react-query';
import http from 'helpers/requests';

export const renderStatusKey = (reportId, slot, inputHash) => [
  'renderStatus',
  reportId,
  slot,
  inputHash,
];

// Content-addressed readiness/poll for a Lambda-rendered slot. Asks the backend:
// "is there a ready render for (slot, inputHash)?" → S3 is the authoritative
// cache (cross-device). Returns { status: 'ready'|'pending'|'absent'|'error'|'expired', url?, message? }.
//
// Same queryKey for the same (report, slot, inputHash), so the passive "is the
// download ready?" check and the active poll during generation share ONE
// underlying request (react-query dedup). Polls only while `pending`.
export default function useRenderStatus(reportId, slot, inputHash, { enabled = true } = {}) {
  return useQuery({
    queryKey: renderStatusKey(reportId, slot, inputHash),
    queryFn: async () => {
      const res = await http.get(`/operator-reports/${reportId}/render-status`, {
        params: { slot, inputHash },
      });
      return res.data;
    },
    enabled: Boolean(enabled && reportId && slot && inputHash),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: Infinity,
    gcTime: 60_000,
    refetchIntervalInBackground: true,
    refetchInterval: (query) => (query.state.data?.status === 'pending' ? 4000 : false),
  });
}
